import { useEffect } from 'react';

export const useCountryListEffects = ({
  skipSearchHandler,
}: {
  skipSearchHandler: () => void;
}) => {
  useEffect(() => {
    skipSearchHandler();
  }, [skipSearchHandler]);
};
